@import '../shared';

.profile-option {
  position: relative;

  .form-radio__image-container {
    height: 8rem;
    width: 8rem;
  }

  @media (min-width: $breakpoint-md) {
    .form-radio__image-container {
      height: 12rem;
      width: 12rem;
    }
  }

  label {
    cursor: pointer;

    &:hover .form-radio__image-container {
      border-color: $blue-border;
    }

    &:active .form-radio__image-container {
      border-color: $blue;
    }
  }

  .form-radio--disabled {
    .form-radio__image {
      opacity: 1;
    }

    .form-radio__image-container {
      border-color: #fff;
    }

    .form-radio__caption {
      font-style: normal;
    }
  }

  &--editing {
    label {
      cursor: default;

      &:hover .form-radio__image-container {
        border-color: #fff;
      }

      &:active .form-radio__image-container {
        border-color: #fff;
      }
    }
  }

  &__edit-button {
    position: absolute;
    bottom: 2.4rem;
    right: 0;
    width: 3.6rem;
    height: 3.6rem;
    border-radius: 50%;
    vertical-align: middle;
    display: flex;
    justify-content: center;
    padding: 0;
  }

  &__edit-button-icon {
    fill: #fff;
  }
}
